export enum AttendeeStatus {
  PASSED = 0,
  NO_FREE_PLACE = 1,
  HAS_FREE_PLACE = 2,
  REGISTERED = 3
}
